import { Column, Img, Row } from "@react-email/components";
import { stripPx } from "@circle-react-shared/Emails/VisualEmailBuilder/Utils/stripPx";
import { defaultStyles } from "./defaultStyles";

export const LogoSection = ({
  logoUrl,
  iconUrl,
  communityName,
}: {
  logoUrl: string | null;
  iconUrl: string | null;
  communityName: string;
}) => {
  if (logoUrl) {
    return (
      <Row style={defaultStyles.logoRow}>
        <Column align="center">
          <Img
            style={{
              height: defaultStyles.image.logoHeight,
              display: "inline-block",
              maxWidth: "100%",
              width: "auto",
            }}
            height={stripPx(defaultStyles.image.logoHeight)}
            src={logoUrl}
            alt={communityName}
          />
        </Column>
      </Row>
    );
  }
  if (iconUrl) {
    return (
      <>
        <Row style={defaultStyles.logoRow}>
          <Column align="center">
            <Img
              style={{
                height: defaultStyles.image.iconHeight,
                width: defaultStyles.image.iconWidth,
              }}
              height={stripPx(defaultStyles.image.iconHeight)}
              width={stripPx(defaultStyles.image.iconWidth)}
              src={iconUrl}
            />
          </Column>
        </Row>
        <Row style={defaultStyles.logoRow}>
          <Column align="center">
            <span style={defaultStyles.communityName}>{communityName}</span>
          </Column>
        </Row>
      </>
    );
  }
  return (
    <Row style={defaultStyles.logoRow}>
      <Column align="center">
        <span style={defaultStyles.communityName}>{communityName}</span>
      </Column>
    </Row>
  );
};
